<template>
  <div class="article-content" >
    <div class="van-hairline--top" style="padding-top:20px"></div>
    <div class="html" id="html" v-html="article.content"></div>
    <div class="time">发布文章时间：{{article.pubdate|fmTime}}</div>
  </div>
</template>
<script>
import 'highlight.js/styles/vs2015.css'
import hljs from 'highlight.js'
export default {
  name: 'ArticleContent',
  props: {
    article: {
      type: Object,
      default: () => ({})
    }
  },
  mounted () {
    document.querySelector('#html').querySelectorAll('pre code').forEach((block) => {
      hljs.highlightElement(block)
    })
  }
}
</script>
<style scoped lang="less">
.article-content {
  width: 100%;
  padding: 25px 16px;
  overflow: hidden;
  .html {
    word-break: break-all;
    /deep/ img {
      max-width:100%;
      background: #f9f9f9;
    }
    /deep/ pre {
      white-space: pre-wrap;
      code {
        white-space: pre;
      }
    }
  }
  .time {
    text-align: right;
    font-size: 12px;
    color: #A5A6AB;
    padding-top: 25px;
  }
}
</style>
